/**
 * Adjusts the date value based on the operator and adds the correct time.
 * @param {Object} filter - The filter object.
 * @param {"gte"|"lte"|"between"|"eq"} filter.operator - The comparison operator.
 * @param {string} filter.field - The field name (not modified here).
 * @param {string|string[]} filter.value - A date string or array of date strings (YYYY-MM-DD).
 * @returns {Object} New filter object with updated value.
 */

function filterDateHandler(filter) {
  const { operator, value } = filter.value;
  const appendStartOfDay = dateStr => {
    const now = new Date(`${dateStr} 15:00`);
    now.setHours(0, 0, 0, 0);
    return now.toISOString();
  };
  const appendEndOfDay = dateStr => {
    const now = new Date(`${dateStr} 15:00`);
    now.setHours(23, 59, 59, 999);
    return now.toISOString();
  };

  let newValue = value;
  let newOperator = operator;

  switch (operator) {
    case 'gte':
      newValue = appendStartOfDay(value);
      break;

    case 'lte':
      newValue = appendEndOfDay(value);
      break;

    case 'eq':
      newValue = [appendStartOfDay(value), appendEndOfDay(value)].join(',');
      newOperator = 'between';
      break;

    case 'between': {
      // Split CSV string into two dates
      const [start, end] = value.split(',').map(v => v.trim());
      if (!start || !end) {
        // between" operator requires a CSV with 2 dates
        return filter;
      }
      newValue = [appendStartOfDay(start), appendEndOfDay(end)].join(',');
      break;
    }

    default:
      return filter;
  }

  return {
    ...filter,
    value: {
      ...filter.value,
      value: newValue,
      operator: newOperator,
    },
  };
}

export default filterDateHandler;
